module.exports = __webpack_public_path__ + "static/monzo-2@2x-634e5f0e678df79dcaf40cef1a5c7013.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/financial-services/monzo-2@2x.jpg
// module id = 2634
// module chunks = 47877783677342